import React from "react";
import { Box, Stack } from "@mui/material";
import SteminpeLeaderboardTopPlaySchool from "../../components/leaderboards/SteminpeLeaderboardTopPlaySchool";

// http://localhost:3001/steminpe/leaderboard/school-play-duration


const SteamTopPlaySchoolLeaderboard = () => {
    // Get orgType from query parameters
    const searchParams = new URLSearchParams(window.location.search);
    const orgType = searchParams.get('org_type') || 'all'; // default to 'all' if not provided

    // You can set orgType based on your needs, for example:
    // orgType = "primary"; // for primary schools
    // orgType = "secondary"; // for secondary schools
    // orgType = "company"; // for companies
    return (
        <Box>
            <SteminpeLeaderboardTopPlaySchool orgType={orgType} />
        </Box>
    );
}
// <Box
//     sx={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         textAlign: "center",
//         bgcolor: "background.default",
//         color: "text.primary",
//     }}
// >
// <SteminpeLeaderboardTopPlaySchool />
// </Box>


export default SteamTopPlaySchoolLeaderboard;